"use client";

import Image from "next/image";

const mentorImages = [
  {
    src: "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/Skills-in-higher-education.jpg",
    alt: "Faculty mentoring students",
  },
  {
    src: "https://cdn.msu.edu.in/school_of_health_science_and_technology_students_af7ff3ca2c.jpg",
    alt: "Industry collaboration session",
  },
  {
    src: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00732-min.JPG",
    alt: "Expert guidance in workshop",
  },
  {
    src: "https://cdn.msu.edu.in/msu-reavamp/images/hostel/DSC00740-min.JPG",
    alt: "Interactive session with industry experts",
  },
];

export default function ExpertMentorship() {
  const marqueeItems = [...mentorImages, ...mentorImages];

  return (
    <section className="py-8 md:py-16 bg-white overflow-hidden">
      <div className="page-container mx-auto mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
          Expert Mentorship & Guidance
        </h2>
        <p className="text-gray-700 text-sm md:text-base lg:text-lg leading-relaxed max-w-5xl">
          At Medhavi Skills University, faculty serve as facilitators, guiding
          students towards industry-relevant academics. Our focus on practical
          skills ensures students gain a competitive edge in their chosen
          fields. Through interactive sessions and industry collaborations, our
          expert faculty bridge the gap between education and real-world
          demands. Here, we prioritize hands-on experiences and industry
          partnerships to equip students with the skills employers seek.
        </p>
      </div>

      {/* Marquee Gallery */}
      <div className="w-full overflow-hidden">
        <div
          className="flex gap-5 marquee overflow-hidden"
          style={{ "--speed": "40s" }}
        >
          {marqueeItems.map((item, index) => (
            <div
              key={index}
              className="min-w-[300px] md:min-w-[450px] lg:min-w-[600px] relative aspect-[16/10] overflow-hidden group"
            >
              <Image
                src={item.src}
                alt={item.alt}
                fill
                className="object-cover transition-transform duration-700 group-hover:scale-110"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
